import "./page/list";
import "./component/sidebar-filter";

Shopware.Module.register("neti-incompleteorderreminder-cart", {
    type: "plugin",
    name: "IncompleteOrderReminder open carts",
    title: "neti-incomplete-order-reminder.main.menuItemGeneralCart",
    icon: "default-device-database",
    routes: {
        list: {
            component: "neti-incompleteorderreminder-cart-list",
            path: "list",
            meta: {
                privilege: "order.viewer",
            },
        },
    },
    navigation: [
        {
            parent: "sw-order",
            label: "neti-incomplete-order-reminder.main.menuItemGeneralCart",
            icon: "default-device-database",
            path: "neti.incompleteorderreminder.cart.list"
        }
    ]
});